import { render, staticRenderFns } from "./UsuarioDetails.vue?vue&type=template&id=41a4de41&scoped=true"
import script from "./UsuarioDetails.vue?vue&type=script&lang=js"
export * from "./UsuarioDetails.vue?vue&type=script&lang=js"
import style0 from "./UsuarioDetails.vue?vue&type=style&index=0&id=41a4de41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4de41",
  null
  
)

export default component.exports